'use strict';

intellidealerAppPartsModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.parts.previousOrders', {
      url: '/previous-orders' +
      '?previousOrdersPagination' +
      '&{previousOrdersSearch:any}',
      params: {
        previousOrdersPagination: angular.toJson({
          sort: 'dateOpened',
          direction: 'desc'
        })
      },
      templateUrl: 'app/scripts/modules/parts/views/previous-orders.html',
      controller: 'PreviousOrdersController',
      resolve: {
        help: function () {
          return 'Parts-_My_Orders.htm';
        },
        breadcrumb: ['$filter', 'language', function($filter, language) { // jshint ignore:line
          return ($filter('language')('mydealer.ui.my_orders.breadcrumb'));
        }],

        previousOrdersPagination: ['$stateParams', function($stateParams) {
          return angular.fromJson($stateParams.previousOrdersPagination);
        }],

        previousOrders: [
          'pageableService',
          'onlinePartsOrdersResource',
          'globalAlertService',
          '$stateParams',
          'previousOrdersPagination',
          function(pageableService, onlinePartsOrdersResource, globalAlertService, $stateParams, previousOrdersPagination) {
            var parameters = {
              historicalOrders: true,
              keywords: $stateParams.previousOrdersSearch ? $stateParams.previousOrdersSearch : ''
            };

            pageableService.addPageableParameters(
              parameters,
              previousOrdersPagination
            );

            return onlinePartsOrdersResource.assignedOrders.get(
              parameters,
              function () {},
              globalAlertService.handleErrorResponse
            ).$promise;
          }
        ]
      }
    }
  );
}]);
